import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getManagerProfileOptions } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { Checkbox, CHECKBOX_SIZE } from '../../../../Checkbox'
import { FormFieldSelectNG } from '../../../../Form'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
  getFormikFormFieldErrorProps,
} from '../../../../Formik'
import { toUserSelectItemsFromOption, UserMultiSelect } from '../../../../User'
import {
  BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER,
  BUILDING_FORM_FIELD_NAME_UPDATE_MANAGER_FOR_ALL_BUILDINGS_IN_GROUP,
} from '../../BuildingForm.constants'

import * as styles from './ManagerField.module.css'

function ManagerField() {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <div className={styles.managerField}>
      <FormikField
        multi
        Component={FormFieldSelectNG}
        Select={UserMultiSelect}
        controlProps={{
          borderless: !isMobileScreenSize,
          contentProps: {
            inputProps: {
              placeholder: t('Building.AssigneePlaceholderKey'),
            },
          },
        }}
        emptyValue={EMPTY_LIST}
        fieldComponentProps={{
          label: `${t('Building.AssigneeLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        getData={getManagerProfileOptions}
        getDataItems={getItemsFromIdwellApiResponse}
        getErrorProps={getFormikFormFieldErrorProps}
        name={BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER}
        tagsProps={{
          className: styles.managerFieldTags,
        }}
        toPreparedItems={toUserSelectItemsFromOption}
      />
      <FormikField
        Component={Checkbox}
        disabled={
          values[BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER].length === 0
        }
        fieldComponentProps={{
          label: !isMobileScreenSize,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('Building.UpdateManagerForAllBuildingInGroupFieldLabelKey')}
        labelClassName={styles.checkboxLabel}
        name={
          BUILDING_FORM_FIELD_NAME_UPDATE_MANAGER_FOR_ALL_BUILDINGS_IN_GROUP
        }
        size={CHECKBOX_SIZE.small}
      />
    </div>
  )
}

export default ManagerField
